import React from "react";
import { Box, Typography } from "@mui/material";
import { Player } from "@lottiefiles/react-lottie-player";
import { useEffect, useState } from "react";
import approve from "./approve.json";
import { LiLink } from "../../common/commonComps";
import { LoginButton } from "../subComps/loginPieces";
import type { AppContext, GetMyGiftOptions, Size } from "../../types";

interface OnTheWayProps {
    context: AppContext;
    size: Size;
    getMyGiftOptions: GetMyGiftOptions;
    sl: number;
}

const OnTheWay = ({ context = {} as AppContext, size, getMyGiftOptions, sl }: OnTheWayProps): React.ReactElement => {
    const [showCheck, setShowCheck] = useState<boolean>(false);
    useEffect(() => {
        setTimeout(() => setShowCheck(true), 100);
    }, []);

    useEffect(() => () => sessionStorage.setItem(`sl`, `1`), []);
    const email = context?.user?.email ?? ``;
    const selectedGift = getMyGiftOptions.rewards[sl];
    return (
        <Box>
            <Box sx={{ height: 150 }}>
                {showCheck && (
                    <Player autoplay keepLastFrame src={approve} style={{ height: `120px`, width: `120px` }} />
                )}
            </Box>
            <Typography
                component="h1"
                variant="h4"
                sx={{
                    fontFamily: `Plus Jakarta Sans`,
                    width: `100%`,
                    fontSize: size === `small` ? `28px` : `36px`,
                    letterSpacing: `0.01em`,
                    fontWeight: 800,
                    textAlign: `center`,
                }}
            >
                Your gift is on the way
            </Typography>
            <Box
                sx={{
                    display: `flex`,
                    flexDirection: `column`,
                    width: `100%`,
                    gap: 1,
                    marginTop: 1,
                    marginBottom: 3,
                }}
            >
                {selectedGift.delivery === `mail` && (
                    <Typography
                        sx={{
                            mt: 2,
                            fontSize: 18,
                            color: `#4a4a4a`,
                            textWrap: `balance`,
                            minWidth: `2px`,
                            fontWeight: 500,
                            textAlign: `center`,
                        }}
                    >
                        Your gift will be mailed to you. Please allow up to 6 weeks for delivery.
                    </Typography>
                )}
                {[`embedded`, `newtab`].includes(selectedGift.delivery) && (
                    <Typography
                        sx={{
                            mt: 2,
                            fontSize: 18,
                            color: `#4a4a4a`,
                            textWrap: `balance`,
                            minWidth: `2px`,
                            fontWeight: 500,
                            textAlign: `center`,
                        }}
                    >
                        Your gift was sent to{` `}
                        <Typography sx={{ fontWeight: 700, display: `inline`, fontSize: 18, verticalAlign: `bottom` }}>
                            {email}
                        </Typography>
                        . It may take up to 10 minutes to arrive. Don&apos;t forget to check your spam folder.
                    </Typography>
                )}

                <Box sx={{ textAlign: `center`, mt: 5 }}>
                    <LiLink to="/account/payouts">
                        <LoginButton
                            sx={{
                                background: `linear-gradient(1deg, #007238, #00a651)`,
                                borderRadius: `50px`,

                                margin: `0 auto`,
                            }}
                            variant="contained"
                        >
                            See My Summary
                        </LoginButton>
                    </LiLink>
                </Box>
            </Box>
        </Box>
    );
};

export default OnTheWay;
